import { observable } from '~/lib/utils/observable';

export default observable('confidential_mr_state', {
  selectedProject: {},
});
